// 숫자를 1000단위로 콤마 포맷팅
export const formatNumber = (number) => {
  if (typeof number !== "number") {
    const parsed = parseFloat(number);
    if (isNaN(parsed)) return number;
    number = parsed;
  }
  return number.toLocaleString();
};

// 시총을 조, 억 단위로 변환 (API의 total 필드는 억원 단위)
export const formatMarketCap = (valueInBillion) => {
  if (!valueInBillion || isNaN(valueInBillion)) return "-";

  const num =
    typeof valueInBillion === "string" ? parseFloat(valueInBillion) : valueInBillion;

  // 이미 억원 단위이므로 10000억 = 1조
  if (num >= 10000) {
    const trillion = (num / 10000).toFixed(1);
    return `${formatNumber(parseFloat(trillion))}조`;
  } else {
    return `${formatNumber(Math.round(num))}억`;
  }
};

// 테마 데이터를 세미콜론으로 분리하고 정리
export const formatThemes = (themes) => {
  if (!themes || typeof themes !== "string") return [];

  return themes
    .split(";")
    .map((theme) => theme.trim())
    .filter((theme) => theme.length > 0);
};

// 등락률에 따른 색상 클래스 반환
export const getRateColorClass = (diff) => {
  if (typeof diff === "string") {
    diff = parseFloat(diff.replace("%", "").replace("+", ""));
  }

  if (isNaN(diff)) return "";
  return diff > 0 ? "positive" : diff < 0 ? "negative" : "";
};

// 등락률 포맷팅 (+ 기호 포함)
export const formatRate = (diff) => {
  if (typeof diff === "string" && (diff.includes("%") || diff.includes("+"))) {
    return diff;
  }

  const num = typeof diff === "string" ? parseFloat(diff) : diff;
  if (isNaN(num)) return "-";

  const sign = num > 0 ? "+" : "";
  return `${sign}${num.toFixed(2)}%`;
};

// 가격 포맷팅 (콤마 추가)
export const formatPrice = (price) => {
  if (!price || isNaN(price)) return "-";

  const num = typeof price === "string" ? parseFloat(price) : price;
  return formatNumber(num);
};

// 거래대금/거래량 포맷팅 (API 원본값에 100만원만 곱해서 정확한 단위로 표시)
export const formatTradingValue = (value) => {
  if (!value || isNaN(value)) return "-";

  const num = typeof value === "string" ? parseFloat(value) : value;

  // API 원본값에 100만원(1000000)을 곱해서 원 단위로 변환
  const valueInWon = num * 1000000;

  if (valueInWon >= 1000000000000) {
    const trillion = (valueInWon / 1000000000000).toFixed(2);
    return `${formatNumber(parseFloat(trillion))}조`;
  } else if (valueInWon >= 100000000) {
    const billion = (valueInWon / 100000000).toFixed(0);
    return `${formatNumber(parseFloat(billion))}억`;
  } else if (valueInWon >= 10000) {
    const thousand = (valueInWon / 10000).toFixed(0);
    return `${formatNumber(parseFloat(thousand))}만`;
  } else {
    return formatNumber(valueInWon);
  }
};

// API 응답 데이터를 테이블에 맞게 변환
export const transformApiData = (apiItem) => {
  return {
    rank: apiItem.rank || apiItem.Rank,
    name: apiItem.stock_name || apiItem.hname,
    price: formatPrice(apiItem.price),
    priceValue: parseFloat(apiItem.price) || 0,
    rate: formatRate(apiItem.diff),
    rateValue: parseFloat(apiItem.diff) || 0,
    tradingValue: formatTradingValue(apiItem.value || apiItem.Value),
    tradingValueRaw: parseFloat(apiItem.value || apiItem.Value) || 0,
    volume: formatNumber(apiItem.volume),
    marketCap: formatMarketCap(apiItem.total), // API의 total 필드 사용 (억원 단위)
    themes: formatThemes(apiItem.themes),
    theme: formatThemes(apiItem.themes).join(", "),
    shcode: apiItem.shcode || apiItem.ex_shcode,
    rawData: apiItem,
  };
};
